import en from './en'
import es from './es'
import de from './de'
import fa from './fa'
import fr from './fr'
import zh from './zh'
import ru from './ru'

export default {
  de: de,
  en: en,
  es: es,
  fa: fa,
  fr: fr,
  zh: zh,
  ru: ru
}
